import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe8ab664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "item-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-flag" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showFlagIcon())
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "flag-div d-flex align-items-center justify-content-center",
            style: _normalizeStyle(_ctx.getAdjustedFlagPosition())
          }, _hoisted_3, 4))
        : _createCommentVNode("", true),
      (_ctx.showTheQuestionNumber())
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            id: "question-number-container",
            style: _normalizeStyle(_ctx.getAdjustedQuestionNumberPosition())
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.getQuestionNumber()), 1)
          ], 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "inner-container",
        style: _normalizeStyle(_ctx.getAdjustedContainerStyle()),
        innerHTML: _ctx.displayData
      }, null, 12, _hoisted_4)
    ])
  ]))
}